module.exports = __webpack_public_path__ + "ToyotaType-Black.ff7f54dffd7d88af260e.otf";


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/assets/mygolf-theme/fonts/toyota/ToyotaType-Black.otf
// module id = ../../../../../src/assets/mygolf-theme/fonts/toyota/ToyotaType-Black.otf
// module chunks = styles